export default {
    // type
    TYPE_PROJECT:           1,
    TYPE_TEAM:              2,
    TYPE_PERSON:            3,
    // mode
    MODE_DAY:               1,
    MODE_WEEK:              2,
    MODE_MONTH:             3,
    // key
    KEY_UP:                 38,
    KEY_DOWN:               40,
    KEY_RIGHT:              39,
    KEY_LEFT:               37,
    // Mouse button
    MOUSE_BUTTON_LEFT:      1,
    MOUSE_BUTTON_MIDDLE:    2,
    MOUSE_BUTTON_RIGHT:     3,
    // Sort types
    SORT_ASC:               1,
    SORT_DESC:              2,
    SORT_TEAM_ASC:          3,
    SORT_TEAM_DESC:         4,
    SORT_AVAILABILITY_ASC:  5,
    SORT_AVAILABILITY_DESC: 6,
    SORT_DEADLINE_ASC:      7,
    SORT_DEADLINE_DESC:     8,
    SORT_PEOPLE_MANUAL:     9,
    SORT_DEPARTMENT_ASC:    10,
    SORT_DEPARTMENT_DESC:   11,
    // Cell icons
    CELL_ICON_HOME:         1,
    CELL_ICON_PLANE:        2,
    CELL_ICON_MEDICAL:      3,
    CELL_ICON_WEATHER:      4,
    CELL_ICON_EDUCTION:     5,
    // Planning
    PLANNING_ALL:           0,
    PLANNING_FULL:          1,
    PLANNING_NOT_FULL:      2,

    // Project planned
    PROJECT_ALL:           0,
    PROJECT_ONLY_PLANNED:  1,
    PROJECT_NOT_PLANNED:   2,

    sizes: {
        // MODE_DAY
        1: {
            hour:      {
                w: 42,
                h: 40
            },
            day:       {
                // 42 * 24 hours
                w: 1008,
                h: 40
            },
            week:      {
                // 1008 * 7 days
                w: 7056,
                h: 40
            },
            intersect: {
                w: 200,
                h: 52
            },
            sidebar:   {
                w:     200,
                title: {
                    h: 25
                }
            },
            slot:      {
                h:  50,
                mb: 20
            }
        },
        // MODE_WEEK
        2: {
            hour:      {
                w: 42,
                h: 90
            },
            day:       {
                w: 100,
                h: 78
            },
            week:      {
                w: 700,
                h: 78
            },
            intersect: {
                w: 200,
                h: 52
            },
            sidebar:   {
                w:     200,
                title: {
                    h: 25
                }
            },
            slot:      {
                h:  50,
                mb: 20
            }
        },
        // MODE_MONTH
        3: {
            hour:      {
                w: 42,
                h: 90
            },
            day:       {
                w: 42,
                h: 90
            },
            week:      {
                w: 294,
                h: 90
            },
            month:     {
                w: 294,
                h: 90
            },
            intersect: {
                w: 200,
                h: 52
            },
            sidebar:   {
                w:     200,
                title: {
                    h: 25
                }
            },
            slot:      {
                h:  50,
                mb: 20
            }
        }
    }
}
